import React, { Component } from "react";
import { Helmet } from "react-helmet";

class PageHelmet extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Grand Maple Properties </title>
          <meta name="description" content="Grand Maple Properties" />
        </Helmet>
      </React.Fragment>
    );
  }
}

export default PageHelmet;
